import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  VStack,
} from '@chakra-ui/react';

const EditAmountModal = ({
  isOpen,
  onClose,
  editAmount,
  setEditAmount,
  editCurrency,
  setEditCurrency,
  onUpdate,
  isUpdating,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Update Source Amount and Currency</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4}>
            <FormControl>
              <FormLabel>Source Currency</FormLabel>
              <Select value={editCurrency} onChange={(e) => setEditCurrency(e.target.value)}>
                <option value='AED'>AED</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>Source Amount</FormLabel>
              <Input
                type='number'
                value={editAmount}
                onChange={(e) => setEditAmount(e.target.value)}
                placeholder='Enter amount'
              />
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant='ghost' mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme='blue' onClick={onUpdate} isLoading={isUpdating}>
            Update
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default EditAmountModal;
